import {Alert} from '../../components/Alert';
import {Constants} from '../../constants';
import {Alerts} from '../../constants/Strings';

export const maxProfileGuard = (numArchives: number, action: () => void) => {
  if (numArchives < Constants.MAX_HEAT_PROFILES) {
    action();
    return true;
  } else {
    Alert.alert(
      Alerts.MAX_HEAT_PROFILES_REACHED_TITLE,
      Alerts.MAX_HEAT_PROFILES_REACHED_MESSAGE,
    );
    return false;
  }
};
